import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ComputerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"computer"}/>
}
